import React from 'react'

function PaymentFailed(props) {
  return (
    <div>Payment failed: {props.err}</div>
  )
}

export default PaymentFailed